import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueGoogleApi from 'vue-google-api'
import 'bootstrap/dist/js/bootstrap.bundle.js'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'line-awesome/dist/line-awesome/css/line-awesome.css'
import DropZone from 'dropzone-vue';
import 'dropzone-vue/dist/dropzone-vue.common.css';
import vueVimeoPlayer from 'vue-vimeo-player';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.css';
import Vue3EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';

// AOS (Animate On Scroll)
import AOS from 'aos'
import 'aos/dist/aos.css'

// create the 'options' object
const clientConfig = {
    apiKey: 'AIzaSyBz8fR0-0JxOwzuLcSmtpQR-OgM8llyJQE',
    clientId: '776599169387-n7tbj84v3kq6p45bk88can47bn1lutnh.apps.googleusercontent.com',
    discoveryDocs: ['https://sheets.googleapis.com/$discovery/rest?version=v4'],
    scope: 'https://www.googleapis.com/auth/calendar',
}

if(window.location.host == 'h.animasana.net' || window.location.host == 'animasana.net'){
  axios.defaults.baseURL = 'https://api.animasana.net'
}else if(window.location.host == 'api-qa.animasana.net'){
  axios.defaults.baseURL = 'https://api-qa.animasana.net'
}else{
  axios.defaults.baseURL = 'https://api-qa.animasana.net'
}

// ❌ Desactivar Service Worker en WebViews iOS problemáticos
const ua = navigator.userAgent || navigator.vendor || window.opera;
const isIOS = /iPhone|iPad|iPod/i.test(ua);
const isWebView = /Instagram|Facebook|WhatsApp/i.test(ua);

if (!(isIOS && isWebView)) {
  // Registrar SW normalmente SOLO si NO estamos en WebView iOS
  import('./registerServiceWorker');
} else {
  console.log('Service Worker no se registra en WebView iOS para evitar pantalla en blanco');
}

// ✅ Crear app
const app = createApp(App)
  .use(store, VueAxios, axios, VueGoogleApi, clientConfig, DropZone, vueVimeoPlayer, Multiselect)
  .component('EasyDataTable', Vue3EasyDataTable)
  .use(router);

// ✅ Inicializar AOS
AOS.init({
  duration: 800,
  once: true,
  easing: 'ease-in-out'
});

app.mount('#app');

// ✅ Manejo de ChunkLoadError para recarga automática
const cleanCacheAndReload = () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(reg => reg.unregister());
    });
  }
  if ('caches' in window) {
    caches.keys().then(cacheNames => cacheNames.forEach(cacheName => caches.delete(cacheName)));
  }
  setTimeout(() => window.location.reload(true), 1000);
};

window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && event.reason.message && event.reason.message.includes('Loading chunk')) {
    console.warn('ChunkLoadError detectado (Promise). Limpiando cache y recargando...');
    cleanCacheAndReload();
  }
});

window.addEventListener('error', (event) => {
  if (event.message && event.message.includes('Loading chunk')) {
    console.warn('ChunkLoadError detectado. Limpiando cache y recargando...');
    cleanCacheAndReload();
  }
});